document.addEventListener('DOMContentLoaded', () => {

  // -----------------------------
  // 動画自動再生
  // -----------------------------
  const videos = document.querySelectorAll("video[data-playing]");
  const videoObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.play().catch(err => {
          console.warn("Autoplay prevented:", err);
        });
        entry.target.dataset.playing = "true";
      } else {
        entry.target.pause();
        entry.target.dataset.playing = "false";
      }
    });
  }, { threshold: 0.5 }); // 50%以上見えたら再生

  videos.forEach(video => {
    video.dataset.playing = "false";
    videoObserver.observe(video);
  });

  // -----------------------------
  // 無限ループスライダー
  // -----------------------------
  document.querySelectorAll('.js-loopSlider').forEach(el => {
    const direction = el.getAttribute('data-swiper-direction');
    const slideCount = el.querySelectorAll('.swiper-slide').length;
    const isReverse = direction === 'left';

    const swiperInstance = new Swiper(el, {
      allowTouchMove: false,
      loop: true,
      loopAdditionalSlides: 1,
      slidesPerView: 'auto',
      speed: 300 * slideCount,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: isReverse
      }
    });

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (!swiperInstance.autoplay.running) {
            swiperInstance.autoplay.start();
            el.setAttribute('data-swiper-state', 'playing');
          }
        } else {
          if (swiperInstance.autoplay.running) {
            swiperInstance.autoplay.stop();
            el.setAttribute('data-swiper-state', 'paused');
          }
        }
      });
    }, { threshold: 0.1 });

    observer.observe(el);
  });

  // -----------------------------
  // スクロールアニメーション
  // -----------------------------
  const animaElements = document.querySelectorAll("[data-scroll-anima]");
  const jsAnimateElements = document.querySelectorAll(".js-animate");

  const animaObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.dataset.scrollAnima = 'true';
      }
    });
  }, { threshold: 0.2 });

  // 単体要素の監視
  animaElements.forEach(el => animaObserver.observe(el));

  // .js-animate 内の子要素をまとめて発火
  const jsAnimateObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const children = entry.target.querySelectorAll("[data-scroll-anima]");
        children.forEach(child => {
          child.dataset.scrollAnima = 'true';
        });
      }
    });
  }, { threshold: 0.2 });

  jsAnimateElements.forEach(el => jsAnimateObserver.observe(el));

  // -----------------------------
  // FAQアコーディオン
  // -----------------------------
  document.querySelectorAll('.js-accordion').forEach(title => {
    title.addEventListener('click', () => {
      const box = title.nextElementSibling;
      if (box.classList.contains('is-open')) {
        box.style.maxHeight = null;
      } else {
        box.style.maxHeight = box.scrollHeight + "px";
      }
      box.classList.toggle('is-open');
    });
  });

  // -----------------------------
  // viewport固定
  // -----------------------------
  const viewport = document.querySelector('meta[name="viewport"]');
  const switchViewport = () => {
    const value = window.innerWidth > 393
      ? 'width=device-width,initial-scale=1'
      : 'width=393';
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  };
  window.addEventListener('resize', switchViewport);
  switchViewport();

  // -----------------------------
  // ページ内リンクスムーススクロール
  // -----------------------------
  document.querySelectorAll('.js-pageLink').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const targetId = link.getAttribute('href');
      const target = document.querySelector(targetId);
      const header = document.getElementById('header');
      if (!target) return;
      const headerHeight = header ? header.offsetHeight : 0;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    });
  });

});

// -----------------------------
// 固定ヘッダー
// -----------------------------
function pageTopAnime() {
  const scroll = window.scrollY;
  const kv = document.getElementById('fv');
  const header = document.getElementById('header');
  if (!kv || !header) return;
  const kvHeight = kv.offsetHeight;
  if (scroll >= kvHeight) {
    header.classList.remove('is-hidden');
    header.classList.add('is-visible');
  } else {
    header.classList.remove('is-visible');
    header.classList.add('is-hidden');
  }
}

// スクロールイベントを requestAnimationFrame で最適化
let ticking = false;
window.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      pageTopAnime();
      ticking = false;
    });
    ticking = true;
  }
});
